import { useCallback, useMemo, useRef } from "react";
import {
  useNavigate,
  useParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";

function useRoutesHelper() {
  const navigate = useNavigate();
  const location = useLocation();

  const [searchRouteParams] = useSearchParams();

  const routeParams = useMemo(
    () => Object.fromEntries(searchRouteParams.entries()),
    [searchRouteParams],
  );

  const routeMainParam = useParams();

  const locationSearchRef = useRef(location.search);
  locationSearchRef.current = location.search;

  const currentUrl = useMemo(() => {
    const withoutHostname = window.location.href
      .replace("http://", "")
      .replace("https://", "");
    return withoutHostname.split("/").slice(1).join("/");
  }, []);

  const handleSetQuerryParams = useCallback(
    (newParams: Record<string, any>) => {
      const searchParams = new URLSearchParams(locationSearchRef.current);

      Object.entries(newParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          searchParams.set(key, String(value));
        } else {
          searchParams.delete(key);
        }
      });

      const query = searchParams.toString();

      const newUrl = query
        ? `${location.pathname}?${query}`
        : location.pathname;

      navigate(newUrl, { replace: true });
    },
    [location.pathname, navigate],
  );

  return {
    routeMainParam,
    routeParams,
    searchRouteParams,
    currentUrl,
    handleSetQuerryParams,
  };
}

export default useRoutesHelper;
